import { IoWarning } from "react-icons/io5";

function getSeverityColor(severity) {
  const severityLower = severity?.toLowerCase() || "";

  if (severityLower === "extreme" || severityLower === "severe") {
    return { background: "rgba(220, 38, 38, 0.7)", color: "white" }; // Red with transparency
  } else if (
    severityLower === "moderate" ||
    severityLower === "minor" ||
    severityLower === "unknown"
  ) {
    return { background: "rgba(251, 191, 36, 0.7)", color: "#1e2938" }; // Yellow with transparency
  }

  return { background: "rgba(251, 191, 36, 0.7)", color: "#1e2938" }; // Default to yellow
}

export default function WeatherDetails({ description, fontColor, warnings }) {
  return (
    <div className="weather-details-container">
      <div className="weather-description-box" style={{ color: fontColor }}>
        {description}
      </div>
      {warnings && warnings.length > 0 && (
        <>
          {warnings.map((warning, index) => {
            const colors = getSeverityColor(warning.severity);
            return (
              <div
                key={index}
                className="weather-alert-box"
                style={{
                  backgroundColor: colors.background,
                  color: colors.color,
                }}
              >
                <IoWarning className="alert-icon" />
                <span className="alert-description">{warning.description}</span>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}
